<input style="display: none" #documentInput type="file"  (change)="fileEvent($event)" [attr.accept]="acceptTypes"  title="Завантажити файл">

<dx-button id="uploudBtn"
          text="Завантажити файл"
          type="default"
          stylingMode="outlined"
          icon="upload"
          (onClick)="showFileDialog()">
</dx-button>
